import { getOcApiHost } from "../Constants/Environment";
import CONSTANTS from "../Constants/Constants";
import { getClient, setFavicon } from "../helpers/general";

const API_URL = getOcApiHost();

export const fetchBookingEngineByAgentId = async (agent_id, path=`\\api\\booking-engine\\agent\\`) => {
    try{
        return await fetch(API_URL+path+agent_id, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then(res => res.json())
        .then(data => {
            return data
        })
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const saveBookedItineraryItem = async (formData, agentToKen, path=`\\api\\itinerary\\booked-itinerary-item\\save\\`) => {
    try{
        return await fetch(API_URL+path, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${agentToKen}`
            },
            body: JSON.stringify(formData)
        })
        .then(res => res.json())
        .then(data => data)
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const freshEngineCleanup = () => {
    if(localStorage.getItem("booking_link"))
        localStorage.removeItem("booking_link");
    if(localStorage.getItem("package_id")){
        localStorage.removeItem("package_id");
    }
}

export const getCustomerActivityObjForTravelAgent = async (trans_const_type) => {

    const SEARCH_OBJ = JSON.parse(localStorage.getItem(CONSTANTS.local_storage.flight_search_object));
    const productType = parseInt(localStorage.getItem(CONSTANTS.local_storage.product_type));
    
    let search_obj_info = ""
    if(CONSTANTS.product_types.flights===parseInt(productType)){
        search_obj_info = `(Flight: ${SEARCH_OBJ?.type}
        , Departure: ${SEARCH_OBJ?.itinerary?.departure?.airport}
        , Take-off Date: ${SEARCH_OBJ?.itinerary?.departure?.date}
        , Destination: ${SEARCH_OBJ?.itinerary?.arrival?.airport}
        , Return Date: ${SEARCH_OBJ?.itinerary?.arrival?.date}
        , Cabin: ${SEARCH_OBJ?.itinerary?.cabin}
        , Total Adults: ${SEARCH_OBJ?.itinerary?.travelers?.adults}
        , Total Children: ${SEARCH_OBJ?.itinerary?.travelers?.children}
        , Total Infants: ${SEARCH_OBJ?.itinerary?.travelers?.infants})`;
    }

    // Getting user agent details
    const client = await getClient();

    let __desc="";
    if(trans_const_type===CONSTANTS?.independent_agent?.transaction?.types?.customer_searched_flight){
        __desc=`Searching: Customer searched flight: ${search_obj_info} - With device: ${client?.device}`;
    }
    if(trans_const_type===CONSTANTS?.independent_agent?.transaction?.types?.view_full_flight_details){
        __desc=`Viewing: Customer viewed full flight details: ${search_obj_info} - With device: ${client?.device}`;
    }
    if(trans_const_type===CONSTANTS?.independent_agent?.transaction?.types?.customer_ordered_flight){
        __desc=`Purchase: Customer purchased flight: ${search_obj_info} - With device: ${client?.device}`;
    }

    const post_obj = {
        oc_user_id: "",
        booking_link_id: "",
        customer_id: "",
        info: client?.device,
        transaction_type_constant: trans_const_type,
        unit_quantity: 1,
        unit_action_point_quantity: 1,
        description: __desc,
    }

    if(localStorage.getItem("agent")){
        const agent_id = localStorage.getItem("agent");
        if(agent_id || agent_id!=="undefined")
            post_obj.oc_user_id = agent_id;
    }
    if(localStorage.getItem("booking_link")){
        let _bl = localStorage.getItem("booking_link");
        if(_bl || _bl!=="undefined"){

            post_obj.booking_link_id = _bl;
            post_obj.description = `Link Created/Viewed: Booking link was opened: ${search_obj_info} - With device: ${client?.device}`;
            post_obj.transaction_type_constant = CONSTANTS?.independent_agent?.transaction?.types?.link_created_loaded;
            
            if(trans_const_type===CONSTANTS?.independent_agent?.transaction?.types?.view_full_flight_details){
                post_obj.description=`Viewing (from Booking Link Flights): Customer viewed full flight details: ${search_obj_info} - With device: ${client?.device}`;
                post_obj.transaction_type_constant=trans_const_type;
            }
            if(trans_const_type===CONSTANTS?.independent_agent?.transaction?.types?.customer_ordered_flight){
                post_obj.description=`Purchase (from Booking Link Flights): Customer purchased flight: ${search_obj_info} - With device: ${client?.device}`;
                post_obj.transaction_type_constant=trans_const_type;
            }
        }
    }
    if(localStorage.getItem("customer")){
        let customer = localStorage.getItem("customer");
        if(customer || customer!=="undefined")
            post_obj.customer_id = customer;
    }
            
    return post_obj;   
}

export const postLinkVistedTransaction = async (payload, path="\\api\\wallets\\agent\\transaction\\visited-link\\create\\") => {
    try{
        return await fetch(API_URL+path, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        })
        .then(res => res.json())
        .then(data => data)
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const getTravelAgentDetails = async (agent_id, path="\\api\\agents\\public\\get-basic-information\\") => {
    try{
        return await fetch(API_URL+path+agent_id, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then(res => res.json())
        .then(data => data)
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const fetchAgentPriceMarkupInfo = async (agent_id, path=`\\api\\agents\\public\\price-markup\\`) => {
    try{
        return await fetch(API_URL+path+agent_id, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then(res => res.json())
        .then(data => data)
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const fetchSupportTicketsByCustomerEmail = async (email, filters, setTotalItemsState=()=>{}, offset=1, limit=10, path=`\\api\\support-ticket\\customer\\all\\`) => {
    try{
        return await fetch(API_URL+path+email+'\\'+offset+'\\'+limit, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                //'Authorization': `Bearer ${USER_TOKEN}`
            },
            body: JSON.stringify({filters})
        })
        .then(res => {
            for (var pair of res.headers.entries()) {
                if (pair[0] === 'pagination-total-items') {
                    setTotalItemsState(pair[1]);
                }
            }
            return res.json();
        })
        .then(data => data)
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const fetchSupportTicketById = async (ticket_id, path=`\\api\\support-ticket\\one\\`) => {
    try{
        return await fetch(API_URL+path+ticket_id, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then(res => res.json())
        .then(data => data)
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const fetchItinerariesByCustomerEmail = async (email, filters, setTotalItemsState=()=>{}, offset=1, limit=10, path=`\\api\\itinerary\\customer\\all\\`) => {
    try{
        return await fetch(API_URL+path+email+'\\'+offset+'\\'+limit, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                //'Authorization': `Bearer ${USER_TOKEN}`
            },
            body: JSON.stringify({filters})
        })
        .then(res => {
            for (var pair of res.headers.entries()) {
                if (pair[0] === 'pagination-total-items') {
                    setTotalItemsState(pair[1]);
                }
            }
            return res.json();
        })
        .then(data => data)
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const fetchHighlightedItinerariesOfAgent = async (agent_id, filters, setTotalItemsState=()=>{}, offset=1, limit=10, path=`\\api\\itinerary\\public\\highlighted\\`) => {
    try{
        return await fetch(API_URL+path+agent_id+'\\'+offset+'\\'+limit, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                //'Authorization': `Bearer ${USER_TOKEN}`
            },
            body: JSON.stringify({filters})
        })
        .then(res => {
            for (var pair of res.headers.entries()) {
                if (pair[0] === 'pagination-total-items') {
                    setTotalItemsState(pair[1]);
                }
            }
            return res.json();
        })
        .then(data => data)
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const fetchItineraryById = async (id, path=`\\api\\itinerary\\customer\\one\\`) => {
    try{
        return await fetch(API_URL+path+id, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then(res =>  res.json())
        .then(data => data)
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const saveSupportTicket = async (formData, path=`\\api\\support-ticket\\create\\`) => {
    try{
        return await fetch(API_URL+path, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                /*'Authorization': `Bearer ${USER_TOKEN}`*/
            },
            body: JSON.stringify(formData)
        })
        .then(res => res.json())
        .then(data =>{ 
            console.log(data);
            return data;
        })
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const getDefaultBookingEngine = () => {
    return {
        enableBookingEngine: true,
        showHeader: true,
        headerBg: "#000",
        headerCompanyTxtColor: "#a9ddff",
        showHeaderCompany: true,
        showHeaderMenu: true,
        headerMenuTxtColor: "#808080",
        headerMenuIconColor: "#FFFFFF80",
        headerMenuActiveTxtColor: "#FFA500",
        headerMenuActiveIconColor: "#FFFF00",
        actionButtonsBg: "#941777",
        actionButtonsTxtColor: "#FFFFFF",
        actionButtonsIconColor: "#ffffff80",
        closeButtonBgColor: "#DC143C",
        closeButtonIconColor: "#FFFFFF",
        showSearchFilters: true,
        searchFiltersTxtColor: "#175794",
        searchFiltersIconColor: "#c751b9",
        searchFiltersIndicatorColor: "#0000007f",
        headerLogoBorderRadius: 100,
        searchButtonBorderRadius: 100,
        actionButtonBorderRadius: 100,
        closeButtonBorderRadius: 100,
        greetingsCardBg: "#000",
        greetingsCardTextColor: "#FFFFFF",
        greetingsCardSecTextColor: "#c9c7c9", 
        greetingsCardIconColor: "#c9c7c9",
        greetingsCardTitleColor: "#c751b9",
        greetingsCardBorderRadius: 9,
        hideGreetingsCard: false,
        hideCompanyLogo: false,
        hideCompanyName: false,
        homePageSearchButtonTextColor: "#FFFFFF",
        homePageSearchButtonBgColor: "#175794",
        homePageSearchButtonIconColor: "#e0e0e0",
        homePageSearchButtonBorderRadius: 50,
        homePageSearchInputBackground: "#FFFFFF",
        homePageSearchInputIconColor: "black",
        homePageSearchInputBorderColor: "#e0e0e0",
        homePageSearchInputborderRadius: 9,
        homePageSearchInputTextColor: "black",
        homePageSearchFormProductTypeSelectorActiveBackground: "#2b343d",
        homePageSearchFormProductTypeSelectorBackground: "#414957",
        homePageSearchFormProductTypeSelectorActiveTextColor: "#87CEEB",
        homePageSearchFormProductTypeSelectorTextColor: "#808080",
        homePageSearchFormProductTypeSelectorActiveIcon: "#D66A92",
        homePageSearchFormProductTypeSelectorIcon: "#665b63",
        homePageSearchFormProducttypeSelectorBorderRadius: 50,
    }
}

(async()=>{
    if(localStorage.getItem("agent")){
        const agent_id = localStorage.getItem("agent");
        if(agent_id || agent_id!=="undefined"){

            // Agent Info
            let __agent_info = await getTravelAgentDetails(agent_id);
            //console.log(__agent_info)
            //alert(__agent_info?.company_info?.business_name)
            setFavicon(__agent_info?.company_info?.logo_url);
            if(__agent_info?.company_info?.business_name)
                document.title = __agent_info?.company_info?.business_name;
            window.__setAgentDetails(__agent_info);

            // Booking Engine
            let __be_info = await fetchBookingEngineByAgentId(agent_id);
            if(!__be_info?._id){
                __be_info=getDefaultBookingEngine();
            }

            // Setting App Level State and adding CSS Rule
            window.__setBESettings(__be_info);
            const styleSheet = document.styleSheets[8];
            styleSheet.insertRule(`
                .cm-toggle:before {
                    background: ${__be_info?.actionButtonsBg};
                }`, 0);
            styleSheet.insertRule(`
                .cm-toggle:checked:after {
                    background: ${__be_info?.actionButtonsBg}90;
                }`, 0);
            
        }
    }
})();

export const fetchDealPackageById = async (agent_id, package_deal_id, path=`\\api\\travel-deals-packages\\public\\one\\`) => {
    try{
        return await fetch(API_URL+path+agent_id+'\\'+package_deal_id, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
        .then(res => res.json())
        .then(data => data)
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const fetchDealsPackagesByAgentID = async (user_id, filters, setTotalItemsState=()=>{}, offset=1, limit=10, path=`\\api\\travel-deals-packages\\all\\`) => {
    try{
        return await fetch(API_URL+path+user_id+'\\'+offset+'\\'+limit, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({filters})
        })
        .then(res => {
            for (var pair of res.headers.entries()) {
                if (pair[0] === 'pagination-total-items') {
                    setTotalItemsState(pair[1]);
                }
            }
            return res.json();
        })
        .then(data => data)
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const createPackageOrder = async (formData, path=`\\api\\travel-deals-packages\\orders\\create\\`) => {
    try{
        return await fetch(API_URL+path, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        })
        .then(res => res.json())
        .then(data =>{ 
            console.log(data);
            return data;
        })
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}

export const fetchProductSpecificServiceFeesByAgentId = async (agent_id, product_type_number, path=`\\api\\service-fee\\of-agent-of-product-type\\`) => {
    try{
        return await fetch(API_URL+path+agent_id+"\\"+product_type_number, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then(res => res.json())
        .then(data => data)
        .catch(err => {
            console.log(err);
            return {isError: true, message: err.message};
        })
    } catch (e){
        console.log(e);
        return {isError: true, message: e.message};
    }
}